import React from "react";
import { useNavigate } from "react-router";
import Button from "../../../primitives/Button";
import { useDispatch } from "react-redux";
import {
  unMountDialog,
} from "../../../../features/util/utilSlice";

interface SomethingWrongProps {
  message?: string;
  isPromoError?: boolean;
  onSubscribeAnyway?: (() => void);
}

const SomethingWrong: React.FC<SomethingWrongProps> = ({ 
  message, 
  isPromoError, 
  onSubscribeAnyway 
}) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleRefresh = () => {
    dispatch(unMountDialog());
    window.history.back()
  };
  const handleTryAgain = () => {
    dispatch(unMountDialog());
    window.location.reload();
  };
  const handleSubscribeAnyway = () => {
    dispatch(unMountDialog());
    if (onSubscribeAnyway) {
      onSubscribeAnyway();
    }
  };


  return (
    <div className="flex flex-col items-center h-fit px-6 justify-center mt-10 gap-y-3">
      <svg
        width="55"
        height="55"
        viewBox="0 0 55 55"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M54.334 37.6666C54.3719 44.7219 49.9631 51.0367 43.3269 53.4325C36.6907 55.8282 29.2649 53.7858 24.7873 48.3333C24.6365 48.3461 24.4848 48.3461 24.334 48.3333H8.04065C3.86797 48.4076 0.421491 45.0924 0.333984 40.9199V7.74659C0.421491 3.57417 3.86797 0.258867 8.04065 0.333259H43.294C47.4667 0.258867 50.9131 3.57417 51.0007 7.74659V26.9999C51.0133 27.1864 51.0133 27.3735 51.0007 27.5599C53.1881 30.4731 54.3592 34.0236 54.334 37.6666ZM37.6673 16.3333H13.6673C12.1946 16.3333 11.0007 15.1394 11.0007 13.6666C11.0007 12.1938 12.1946 10.9999 13.6673 10.9999H37.6673C39.1401 10.9999 40.334 12.1938 40.334 13.6666C40.334 15.1394 39.1401 16.3333 37.6673 16.3333ZM45.6673 23.0533C43.2177 21.7019 40.4649 20.9954 37.6673 20.9999C32.2989 21.0011 27.2597 23.5881 24.1298 27.9498C21 32.3115 20.1627 37.9138 21.8807 42.9999H8.04065C6.81252 43.0761 5.75285 42.1474 5.66732 40.9199V7.74659C5.75285 6.51908 6.81252 5.59037 8.04065 5.66659H43.294C44.5221 5.59037 45.5818 6.51908 45.6673 7.74659V23.0533ZM49.0006 37.6666C49.0006 31.4074 43.9265 26.3333 37.6673 26.3333C31.4081 26.3333 26.334 31.4074 26.334 37.6666C26.334 43.9258 31.4081 48.9999 37.6673 48.9999C43.9205 48.9853 48.986 43.9197 49.0006 37.6666ZM40.7607 31.8911C41.4717 31.8911 42.1533 32.1751 42.654 32.6799C43.1588 33.1806 43.4428 33.8622 43.4428 34.5733C43.4428 35.2843 43.1588 35.9659 42.654 36.4666L41.4273 37.6666L42.654 38.8666C43.1588 39.3673 43.4428 40.0489 43.4428 40.7599C43.4428 41.471 43.1588 42.1525 42.654 42.6533C42.1507 43.1524 41.4695 43.4307 40.7607 43.4266C40.0518 43.4307 39.3706 43.1524 38.8673 42.6533L37.6673 41.4266L36.4673 42.6533C35.9641 43.1524 35.2828 43.4307 34.574 43.4266C33.8652 43.4307 33.1839 43.1524 32.6807 42.6533C32.1758 42.1525 31.8919 41.471 31.8919 40.7599C31.8919 40.0489 32.1758 39.3673 32.6807 38.8666L33.9073 37.6666L32.6807 36.4666C31.635 35.4209 31.635 33.7256 32.6807 32.6799C33.7263 31.6343 35.4217 31.6343 36.4673 32.6799L37.6673 33.9066L38.8673 32.6799C39.368 32.1751 40.0496 31.8911 40.7607 31.8911Z"
          fill="#D47C4A"
        />
      </svg>
      <div className="flex flex-col gap-y-3 md:gap-y-3">
        <div className="flex flex-col gap-y-2 items-center max-w-md">
          <p className=" font-custom text-black_primary text-2xl font-bold text-center">
            Oops... something went wrong
          </p>
          {message && (
            <p className="font-custom text-base font-semibold text-center w-80 text-red_error">
              {message}
            </p>
          )}
          <p className="font-custom text-base font-normal text-center ">
            Please review your billing details and try again. If the issue persists, try refreshing the page or navigate back to our homepage.
          </p>
        </div>
        <div className="w-full flex flex-col gap-y-2 justify-center items-center">
          <div className="flex justify-center space-x-4 w-full">
            <Button
              format={{
                id: `refresh-btn`,
                type: "primary",
                content: isPromoError ? "Try again" : "Refresh",
                isFilled: true,
                width: "100%",
                onclick: isPromoError ? handleTryAgain : handleRefresh,
              }}
            />
            { isPromoError &&
            <Button
              format={{
                id: `refresh-btn`,
                type: "primary",
                content: isPromoError ? "Subscribe anyway" : "Refresh",
                isFilled: false,
                width: "100%",
                onclick: handleSubscribeAnyway,
              }}
            />}
          </div>
          <div className="flex flex-col justify-center items-center pb-5">
            {/* <a
            onClick={() => navigate("/login")}
            className="underline font-custom font-normal text-base text-green_primary mb-2"
          >
            Back to Sign in
          </a> */}
            <p>
              Reach out to{" "}
              <a
                href="https://www.bulletproofinbox.com/contact"
                target={"_blank"}
                rel="noreferrer"
                className="underline text-base text-green_primary"
              >
                support@bulletproofinbox.com
              </a>{" "}
              if you have any questions or concerns.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SomethingWrong;
